import * as React from "react";
import "./index.scss";
import Lottie from "lottie-react";
import loader from "./piechartloader.json";
interface INotFoundPageProps {}

const GraphLoader: React.FunctionComponent<INotFoundPageProps> = (props) => {
  return (
    <div className="loading-wrapper_graph  d-flex w-100 my-5">
      <div className="loading-wrapper__details">
        {/* <img src="/gif/loading.gif" className="loading-image img-fluid" /> */}
        <Lottie
          animationData={loader}
          loop={true}
          style={{ height: "455px", width: "455px" }}
        />
      </div>
    </div>
  );
};

export default GraphLoader;
